import axios from 'axios'
import Toaster from '../components/Toaster'

/**
 * Mostra a resposta no toaster, caso venha mensagem do backend.
 *
 * @param Response response dados que foram enviados
 *
 */
function responseHandler(response) {
  if (!response.data.hasOwnProperty('message')) {
    return;
  }

  let data = response.data
  let status = data.status
  let message = data.message

  Toaster.toast({message: message, status: status})
}

/**
 * Intercepta a resposta e envia para o toaster
 *
 */
axios.interceptors.response.use(response => {
  responseHandler(response)
  return response
}, error => {
  if (!error.config.hasOwnProperty('errorHandle') || error.config.errorHandle !== false) {
    responseHandler(error.response)
  }

  return Promise.reject(error.response)
})

export default responseHandler
